import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
export var Container = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  ", ";\n"])), function (_a) {
    var fullHeight = _a.fullHeight;
    return (fullHeight ? "flex-grow: 1" : "");
});
var templateObject_1;
